export default {
	tabs: {
		personal: 'المعلومات الشخصية',
		academic: 'المؤهلات العلمية',
		experience: 'الخبرات العملية',
		attachments: 'مرفقات'
	}
};
